import styled from "styled-components";
export const Container = styled.main`
  display: flex;
  height: 100vh;
  min-height: 100vh;
`;

export const ImageContainer = styled.div`
  width: 50%;
  /* height: 100vh;
  min-height: 100vh; */
  @media screen and (max-width: 1000px) {
    display: none;
  }
`;

export const Image = styled.img`
  width: 100%;
  object-fit: cover;
  height: -webkit-fill-available;
`;

export const FormAndLogoContainer = styled.section`
  width: 50%;
  padding: 2rem 6rem 7rem 6rem;

  @media screen and (max-width: 1000px) and (min-width: 769px) {
    padding: 2rem 4rem 7rem 4rem;
  }
  @media screen and (max-width: 1000px) {
    padding: 0.5rem;
    width: 100%;
    max-width: 450px;
    margin: auto;
  }
  height: 100vh;
  background-color: #ffffff;
  @media screen and (max-width: 768px) {
  }
`;
export const LogoContainer = styled.div`
  display: flex;
  width: 98%;
  justify-content: flex-end;
  @media screen and (max-width: 1000px) {
    margin: 20px 0;
    width: 100%;
    justify-content: center;
  }
`;
export const FormContainer = styled.div`
  margin: 4rem 0 0 0;
  width: 100%;
  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 0rem 20px 50px 20px;
    margin-bottom: 50px;
    overflow: hidden;
  }
`;
